import script from "./SearchPageSearchBarDropdownResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchBarDropdownResults.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchBarDropdownResults.vue?vue&type=style&index=0&id=2680fff5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2680fff5"]])

export default __exports__